import { render } from "./index.vue?vue&type=template&id=41c67990&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=41c67990&scoped=true&lang=css"

import exportComponent from "/home/runner/work/bomoindustrial-vue/bomoindustrial-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41c67990"]])

export default __exports__